<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<p class="centerf"><a id="page_v"></a><em>’Son mo charaidean Gaidhealach uile</em></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?429f45a7